import React from "react"
import { RenderElementProps } from "slate-react"

const ArticleUl = ({ children, attributes }: RenderElementProps) => {
    return (
        <ul
            {...attributes}
            className="mb-6 list-disc list-outside text-md/[28px] last:mb-0 lg:mb-7 lg:text-lg/[31px]"
        >
            {children}
        </ul>
    )
}

export default ArticleUl
